import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { coursesApi } from "../api/coursesApi";
import toast from "react-hot-toast";
import { getErrorMessage } from "@/lib/api";

interface CourseFilters {
  page?: number;
  limit?: number;
  search?: string;
  category?: string;
  level?: string;
  isFree?: boolean;
  sort?: "recent" | "popular" | "price-asc" | "price-desc" | "title";
}

export function useCourses(filters: CourseFilters = {}) {
  return useQuery({
    queryKey: ["courses", filters],
    queryFn: () => coursesApi.list(filters),
  });
}

export function useCourse(slug: string) {
  return useQuery({
    queryKey: ["course", slug],
    queryFn: () => coursesApi.getBySlug(slug),
    enabled: !!slug,
  });
}

export function useCourseById(id: string) {
  return useQuery({
    queryKey: ["course-by-id", id],
    queryFn: () => coursesApi.getById(id),
    enabled: !!id,
  });
}

export function useEnrollCourse() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (courseId: string) => coursesApi.enroll(courseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["courses"] });
      queryClient.invalidateQueries({ queryKey: ["course"] });
      queryClient.invalidateQueries({ queryKey: ["enrollments"] });
      toast.success("Te has inscrito exitosamente");
    },
    onError: (error) => {
      toast.error(getErrorMessage(error));
    },
  });
}

export function useCourseProgress(courseId: string) {
  return useQuery({
    queryKey: ["course-progress", courseId],
    queryFn: () => coursesApi.getProgress(courseId),
    enabled: !!courseId,
  });
}
